import { computed } from 'vue';
import { useStore } from 'vuex';
import { decode } from '@common-vue/util/src/modules/entities';
import { useTitle } from '@vueuse/core';
import { useUpc } from '@modules/upc';
import { useProduct } from '@modules/product';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { useBrand } from '@composables/useBrand';

export const useConsolidatedProductDetails = () => {
  const { productData, productId } = useProduct();
  const { selectedUpcId } = useUpc(productId);
  const { isMcom } = useBrand();

  const store = useStore();
  const firstUpcIdForSelectedLatchkey = computed(() => store.state.extraStore.latchkey.firstUpcIdForSelectedLatchkey);
  const upcIdSource = computed(() => selectedUpcId.value || firstUpcIdForSelectedLatchkey.value);
  const productDetail = computed(() => productData.relationships?.upcs?.[upcIdSource.value]?.detail);
  const productName = computed(() => productDetail?.value?.name || '');

  if (isMcom) {
    const { productName: nameRaw, brandName, secondaryDescription } = useCommonProductGetters({ productId });

    const updatedProductName = computed(() => productName.value || nameRaw.value);

    const consolidatedTitle = computed(() => {
      let titleTag = `${brandName.value || ''} ${secondaryDescription.value} ${updatedProductName.value}`.trim();
      titleTag += " - Macy's";
      return decode(titleTag);
    });
    useTitle(consolidatedTitle);
  }

  return {
    selectedUpcDetail: productDetail,
    productName,
  };
};

export default useConsolidatedProductDetails;
